import { RESET_VERIFIED_USER, SET_VERIFIED_USER } from '../actions'

const initialState = {
    isVerified: false,
    verifiedToken: null
}

export default (state = initialState, action) => {
    switch (action.type) {
    case SET_VERIFIED_USER:
        return {
            ...state,
            isVerified: true,
            verifiedToken: action.payload
        }
    case RESET_VERIFIED_USER:
        return {
            ...state,
            isVerified: false,
            verifiedToken: null
        }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./resources/js/redux/reducers/verifiedReducer.js